import { useEffect } from 'react'
import { useFocusStore } from '@/stores/focusStore'
import { useWakeLock } from './useWakeLock'

/**
 * Drives the focus timer with a 1-second interval.
 * Mount this once (in App or FocusMode).
 * Screen Wake Lock: 집중 모드 실행 중 화면 꺼짐 방지.
 */
export function useFocusTimer() {
  const isActive = useFocusStore((s) => s.isActive)
  const isRunning = useFocusStore((s) => s.isRunning)
  const tick = useFocusStore((s) => s.tick)

  // Screen Wake Lock — 집중 모드 + 타이머 실행 중 화면 유지
  useWakeLock(isActive && isRunning)

  useEffect(() => {
    if (!isActive || !isRunning) return

    const interval = setInterval(tick, 1000)
    return () => clearInterval(interval)
  }, [isActive, isRunning, tick])
}
